import { DomainModel } from 'domains/models';
import { ActionType } from './actionType';
import { TriggerEvent } from './triggerEvent';
import { TriggerType } from './triggerType';

interface Props {
  eventTypeId: number;
  teamId: number;
  timing: number;
  triggerEvent: TriggerEvent;
  triggerType: TriggerType;
  actionType: ActionType;
}

export default class EventTypeWorkflow extends DomainModel {
  eventTypeId: number;
  teamId: number;
  timing: number;
  triggerEvent: TriggerEvent;
  triggerType: TriggerType;
  actionType: ActionType;

  constructor(props: Props) {
    super(props);
    this._className = 'EventTypeWorkflow';
    this.eventTypeId = props.eventTypeId;
    this.teamId = props.teamId;
    this.timing = props.timing;
    this.triggerEvent = props.triggerEvent;
    this.triggerType = props.triggerType;
    this.actionType = props.actionType;
  }

  static permited = ['timing', 'triggerEvent', 'triggerType', 'actionType'];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }

  isValid(scopes: string[] | null = null) {
    super.beforeValidate();
    const p = '';

    return super.isValid();
  }

  static getMaxWorkflowSettingCount() {
    return 5;
  }

  static getMaxWorkflowRemindMinutes() {
    // 4週間
    return 60 * 24 * 7 * 4;
  }

  static isRemindMail(workflow: EventTypeWorkflow) {
    if (
      workflow.triggerEvent === TriggerEvent.EventStart &&
      workflow.triggerType === TriggerType.Before &&
      workflow.actionType === ActionType.Mail
    ) {
      return true;
    }

    return false;
  }

  static isRemindTextMessage(workflow: EventTypeWorkflow) {
    if (
      workflow.triggerEvent === TriggerEvent.EventStart &&
      workflow.triggerType === TriggerType.Before &&
      workflow.actionType === ActionType.TextMessage
    ) {
      return true;
    }

    return false;
  }
}
